import styled from 'styled-components';
import { ListIcon, MapIcon } from 'svg';
import { useStateContext } from '../../context';
import { colors } from '../../constants';

interface IIconButton {
    $isActive: boolean;
}

const IconButton = styled.div<IIconButton>`
    color: ${({ $isActive }) => ($isActive ? colors.orange : colors.black)};
    border-bottom: 1px solid
        ${({ $isActive }) => ($isActive ? colors.orange : colors.greyLight)};
`;

interface IProps {
    className?: string;
}

const BaseToggleViewBar = ({ className }: IProps) => {
    const { showMobileMap, setShowMobileMap } = useStateContext();

    return (
        <div className={className}>
            <IconButton
                onClick={() => setShowMobileMap(false)}
                $isActive={!showMobileMap}
            >
                <ListIcon />
                <span>Lijst</span>
            </IconButton>
            <IconButton
                onClick={() => setShowMobileMap(true)}
                $isActive={showMobileMap}
            >
                <MapIcon />
                <span>Kaart</span>
            </IconButton>
        </div>
    );
};

export const ToggleViewBar = styled(BaseToggleViewBar)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-around;
    overflow-x: clip;
    width: 100%;

    ${IconButton} {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.875rem;
        padding: 0.5rem 0.75rem;
        user-select: none;
        cursor: pointer;
    }

    ${ListIcon}, ${MapIcon} {
        height: 24px;
        width: 24px;
    }

    span {
        margin-left: 0.5rem;
    }
`;
